import { createSelector } from 'reselect';
import { ActionBehaviour, IActionBasic } from 'types/domain/action';
import { selectFeedNext } from './action/actionNext';
import { Mode } from 'core/slices/session';
import { IActionFeedItem } from './action/actionFeed';
import { RootState } from 'types';
import { IEntityReducer } from 'core/reducers/entities';
import { EntityTypes } from 'constants/entities';
import { parseAction } from './action/action';
import { SceneType } from 'types/domain/scene';
import { selectShouldAnimate } from './shouldAnimate';
import { selectSessionMode } from '../admin/sessionMode';

const entity = (state: RootState) => state.entity.present;
const actionId = (state: RootState, id?) => id || state.state[EntityTypes.ACTION];
const nextItem = selectFeedNext;
const shouldAnimate = selectShouldAnimate;
const mode = selectSessionMode

export const selectShouldPause = createSelector(
  [entity, nextItem, actionId, shouldAnimate, mode],
  (entity: IEntityReducer, nextItem: IActionFeedItem, actionId: number, shouldAnimate: boolean, mode: Mode) => {
    const nextAction: IActionBasic = parseAction(entity, nextItem?.actionId);
    return !nextAction || !nextAction.sceneId || mode === Mode.PREVIEW
      ? true
      : nextAction.scene?.type === SceneType.VIDEO && nextAction.behaviour !== ActionBehaviour.PAUSE
      ? false
      : shouldAnimate;
  },
);

//return mode === Mode.ADMIN
// ? childAction && action
//   ? action.behaviour === ActionBehaviour.PLAY
//     ? action.sceneConfig
//       ? Math.abs(action.sceneConfig.end - childAction.sceneConfig?.start) > 0.02
//       : false
//     : true
//   : true
// : nextItem
// ? nextItem.actionId && action && nextItem.actionId === action.childId
//   ? action.behaviour !== ActionBehaviour.PLAY
//   : true
// : true;
